(() => {
  'use strict';
  const plainMoney = value => new DOMParser().parseFromString(String(value || ''),'text/html').body.textContent;
  const color = name => {
    const colors = {black:'#111',darkgreen:'#294236',silver:'#c0c2c4',cementgray:'#a4aaa7',matteblack:'#222',mattedarkgray:'#505658',darkgray:'#555b60',darkred:'#752f35',electrosilver:'#c4c8ca',titaniumgrey:'#858a8e',darkgrayblack:'linear-gradient(135deg,#596068 50%,#171717 50%)',darkgreenblack:'linear-gradient(135deg,#294236 50%,#171717 50%)',redblack:'linear-gradient(135deg,#8e3036 50%,#171717 50%)',satinsilver:'#c6c8ca',mattetitaniumgray:'#858a8e',emeralddarkgreen:'#294236',cosmicblack:'#111111',tiffanyblue:'#75c4bf',white:'#fff',blue:'#41638a',orange:'#d98736',green:'#1c4934',red:'#8e3036',gray:'#888',grey:'#888'};
    return colors[String(name).toLowerCase().replace(/[^a-z0-9]/g,'')] || '#888';
  };
  const homeReady = new WeakSet();
  const initColors = () => document.querySelectorAll('[data-ct-home-variants]').forEach(card => {
    if (homeReady.has(card)) return;
    homeReady.add(card);
    const data = JSON.parse(card.querySelector('[data-ct-home-variant-data]').textContent);
    data.variants.forEach(variant => {variant.priceText = plainMoney(variant.priceText);variant.compareAtText = plainMoney(variant.compareAtText);});
    let selected = data.variants.find(v => v.id === data.selectedId) || data.variants[0];
    const swatches = [...card.querySelectorAll('[data-ct-home-color]')];
    const update = variant => {
      if (!variant) return;
      selected = variant;
      card.dataset.ctSelectedVariantId = String(variant.id);
      const cardInput = card.querySelector('[data-ct-card-variant]');
      if (cardInput) cardInput.value = String(variant.id);
      const cardAdd = card.querySelector('[data-ct-pd-add]');
      if (cardAdd) cardAdd.disabled = !data.variants.some(value => value.available);
      swatches.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.ctHomeColor === variant.options[data.colorPosition])));
      const colorLabel = card.querySelector('[data-ct-home-color-label]');
      if (colorLabel) colorLabel.textContent = variant.options[data.colorPosition];
      const url = new URL(data.url,document.baseURI);url.searchParams.set('variant',variant.id);
      card.querySelectorAll('[data-ct-home-product-link]').forEach(link => {link.href = url.pathname+url.search;});
      card.querySelector('[data-ct-home-price]').textContent = variant.priceText;
      const compareAt = card.querySelector('[data-ct-home-compare-price]');
      compareAt.hidden = variant.compareAt <= variant.price; compareAt.textContent = variant.compareAtText;
      const note = card.querySelector('[data-ct-home-variant-note]');
      if (note) {const option = data.options?.[data.configurationPosition];note.textContent = option?.values.find(value => value.value === variant.options[data.configurationPosition])?.label || '';}
      const image = card.querySelector('.ct-product__image img');
      if (variant.image && image) {image.removeAttribute('srcset');image.src = variant.image;}
      const checkbox = card.querySelector('[data-ct-compare]');
      if (checkbox) {
        checkbox.dataset.price = variant.priceText;checkbox.dataset.url = url.pathname+url.search;
        if (variant.image) checkbox.dataset.image = variant.image;
        if (checkbox.checked) checkbox.dispatchEvent(new Event('change',{bubbles:true}));
      }
    };
    swatches.forEach(button => {button.style.background = color(button.dataset.ctHomeColor);button.addEventListener('click',() => {
      const value = button.dataset.ctHomeColor;
      const exact = data.variants.find(v => v.options[data.colorPosition] === value && v.options.every((item,index) => index === data.colorPosition || item === selected.options[index]));
      const next = exact || data.variants.find(v => v.options[data.colorPosition] === value && v.options[data.configurationPosition] === selected.options[data.configurationPosition] && v.available) || data.variants.find(v => v.options[data.colorPosition] === value && v.available) || data.variants.find(v => v.options[data.colorPosition] === value);
      update(next);
    });});
    update(selected);
  });
  const boot = () => {
    initColors();
    const dialog = document.querySelector('[data-ct-cart]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const data = JSON.parse(dialog.querySelector('[data-ct-cart-data]').textContent);
    const labels = data.labels;
    const fitDataNode = document.querySelector('[data-ct-fit-data]');
    const fitCatalog = fitDataNode ? JSON.parse(fitDataNode.textContent) : null;
    const catalogModels = fitCatalog ? [...fitCatalog.models, ...(fitCatalog.current ? [fitCatalog.current] : [])] : [];
    const cartVariantLabel = (item, children = []) => {
      const model = catalogModels.find(model => model.variants.some(variant => variant.id === item.variant_id));
      const variant = model?.variants.find(variant => variant.id === item.variant_id);
      const finish = children.some(child => child.properties?._ct_upgrade === 'holographic');
      return variant ? variant.options.map((value,index) => finish && /colou?r/i.test(model.options[index]?.name || '') ? labels.upgrade_holographic : model.options[index]?.values.find(option => option.value === value)?.label || value).join(' / ') : item.variant_title;
    };
    const rootURL = data.root.endsWith('/') ? data.root : data.root+'/';
    const status = dialog.querySelector('[data-ct-cart-status]');
    const retry = dialog.querySelector('[data-ct-cart-retry]');
    const confirmation = dialog.querySelector('[data-ct-cart-confirmation]');
    const accessories = dialog.querySelector('.ct-cart-accessories');
    let busy = false, cart = null, opener = null, closing = null;
    const reduced = window.matchMedia('(prefers-reduced-motion:reduce)');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:cart?.currency || data.currency || 'USD'}).format(cents/100)+' '+(cart?.currency || data.currency || 'USD');
    const element = (tag, className, text) => {const el = document.createElement(tag);if (className) el.className = className;if (text !== undefined) el.textContent = text;return el;};
    const setStatus = (text = '', error = false) => {status.textContent = text;status.dataset.error = String(error);};
    const request = async (path, body) => {
      const response = await fetch(rootURL+path,{method:body ? 'POST' : 'GET',headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})},credentials:'same-origin',...(body ? {body:JSON.stringify(body)} : {})});
      const json = await response.json();
      if (!response.ok) throw new Error(typeof json.description === 'string' ? json.description : typeof json.message === 'string' ? json.message : labels.error);
      return json;
    };
    const setBusy = value => {
      busy = value;dialog.classList.toggle('is-busy',value);dialog.setAttribute('aria-busy',String(value));
      dialog.querySelectorAll('[data-ct-cart-items] button').forEach(button => {button.disabled = value;});
      dialog.querySelector('[data-ct-cart-checkout]').disabled = value || !cart?.item_count;
    };
    const show = () => {
      if (closing) {clearTimeout(closing);closing = null;}
      dialog.classList.remove('is-closing');
      if (!dialog.open) {opener = document.activeElement;dialog.showModal();document.documentElement.classList.add('ct-cart-open');requestAnimationFrame(() => dialog.classList.add('is-open'));}
      else dialog.classList.add('is-open');
    };
    const close = () => {
      if (!dialog.open) return;
      dialog.classList.add('is-closing');dialog.classList.remove('is-open');
      closing = setTimeout(() => {dialog.close();dialog.classList.remove('is-closing');document.documentElement.classList.remove('ct-cart-open');opener?.focus();closing = null;},reduced.matches ? 0 : 500);
    };
    const render = next => {
      cart = next;
      const count = cart.items.filter(item => !item.parent_relationship?.parent_key).reduce((sum,item) => sum+item.quantity,0);
      document.querySelectorAll('[data-ct-cart-count]').forEach(el => {el.textContent = String(count);});
      dialog.querySelector('[data-ct-cart-title-count]').textContent = String(count);
      dialog.querySelector('[data-ct-cart-subtotal]').textContent = money(cart.total_price);
      dialog.querySelector('[data-ct-cart-empty]').hidden = !!cart.item_count;
      dialog.querySelector('[data-ct-cart-footer]').hidden = !cart.item_count;
      const discount = dialog.querySelector('[data-ct-cart-discount]');
      discount.hidden = !(cart.total_discount > 0);discount.textContent = labels.savings+': '+money(cart.total_discount);
      const items = dialog.querySelector('[data-ct-cart-items]');items.replaceChildren();
      cart.items.forEach(item => {
        if (item.parent_relationship?.parent_key) return;
        const children = cart.items.filter(child => child.parent_relationship?.parent_key === item.key);
        const article = element('article','ct-cart-line');article.dataset.key = item.key;article.dataset.quantity = String(item.quantity);
        const imageLink = element('a','ct-cart-line__image');imageLink.href = item.url;
        if (item.image) {const img = element('img');img.src = item.image;img.alt = item.product_title;img.width = 120;img.height = 100;imageLink.append(img);}
        const modelTitle = item.product_title.replace(/cyctrace|cyctrac/gi,'CYCTRAC').replace(/\s+(?:M6100|M6250|Wheelt?top|U4000|RS-10S)[\s\S]*?(?=\s+Electric|$)/i,'');
        const body = element('div');const title = element('h3');const link = element('a','',modelTitle);link.href = item.url;title.append(link);body.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') body.append(element('p','',cartVariantLabel(item,children)));
        const properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value);
        if (properties.length) {
          const list = element('dl','ct-cart-line__properties');
          properties.forEach(([key,value]) => {const row = element('div');row.append(element('dt','',key),element('dd','',String(value)));list.append(row);});
          body.append(list);
        }
        if (children.length) {
          const list = element('ul','ct-cart-line__upgrades');
          children.forEach(child => {
            const row = element('li');row.dataset.key = child.key;row.dataset.quantity = String(child.quantity);
            const name = child.properties?._ct_upgrade === 'holographic' ? labels.upgrade_holographic : child.properties?._ct_upgrade === 'motor' ? labels.upgrade_motor : child.product_title;
            row.append(element('span','',name),element('strong','',money(child.final_price)+' × '+child.quantity));list.append(row);
          });
          body.append(list);
        }
        const finalUnit = (item.final_line_price+children.reduce((sum,child) => sum+child.final_line_price,0))/item.quantity;
        const originalUnit = (item.original_line_price+children.reduce((sum,child) => sum+child.original_line_price,0))/item.quantity;
        const price = element('div','ct-cart-line__price');price.append(element('strong','',money(finalUnit)));
        if (originalUnit > finalUnit) price.append(element('s','',money(originalUnit)));
        body.append(price);
        const controls = element('div','ct-cart-line__controls');
        const quantity = element('div','ct-cart-line__quantity');quantity.setAttribute('aria-label',labels.quantity);
        const decrease = element('button','','−');decrease.type = 'button';decrease.setAttribute('aria-label',labels.decrease);decrease.dataset.ctCartQuantity = String(item.quantity-1);
        const number = element('span','',String(item.quantity));
        const increase = element('button','','+');increase.type = 'button';increase.setAttribute('aria-label',labels.increase);increase.dataset.ctCartQuantity = String(item.quantity+1);
        quantity.append(decrease,number,increase);
        const remove = element('button','ct-cart-line__remove',labels.remove);remove.type = 'button';remove.dataset.ctCartQuantity = '0';
        controls.append(quantity,remove);body.append(controls);article.append(imageLink,body);items.append(article);
      });
      retry.hidden = true;
      if (accessories && !cart.item_count) accessories.hidden = true;
      setBusy(busy);
    };
    const read = async () => {
      if (busy) return;
      setBusy(true);setStatus(labels.loading);retry.hidden = true;
      try {render(await request('cart.js'));setStatus();}
      catch (error) {setStatus(error.message || labels.refresh_error,true);retry.hidden = false;}
      finally {setBusy(false);}
    };
    const open = async () => {confirmation.hidden = true;if (accessories) accessories.hidden = false;show();await read();};
    const add = async (id, quantity, form, button) => {
      if (busy) return;
      const amount = Math.max(1,Math.floor(Number(quantity)||1));
      const properties = {};
      if (form) new FormData(form).forEach((value,key) => {const match = key.match(/^properties\[(.+)\]$/);if (match && typeof value === 'string' && value) properties[match[1]] = value;});
      const paid = [...(form?.querySelectorAll('[data-ct-upgrade-variant]:checked') || [])].filter(input => !input.disabled && Number(input.dataset.ctUpgradeVariant) > 0);
      const group = paid.length ? crypto.randomUUID() : null;
      if (group) properties._ct_build = group;
      const parent = {id:Number(id),quantity:amount,...(Object.keys(properties).length ? {properties} : {})};
      const payload = {items:[parent,...paid.map(input => ({id:Number(input.dataset.ctUpgradeVariant),quantity:amount,parent_id:Number(id),properties:{_ct_build:group,_ct_upgrade:input.dataset.ctPdUpgrade}}))]};
      const formStatus = form?.querySelector('[data-ct-form-status]');
      const oldText = button.textContent;
      setBusy(true);button.disabled = true;button.textContent = labels.adding;
      form?.closest('[data-ct-pd-root]')?.dispatchEvent(new CustomEvent('ct:cart-busy',{detail:true}));
      if (formStatus) {formStatus.textContent = labels.adding;formStatus.dataset.error = 'false';}
      let added = false;
      try {
        await request('cart/add.js',payload);
        added = true;
        if (form?.hasAttribute('data-ct-quick-form')) quickDialog?.close();
        confirmation.hidden = false;confirmation.textContent = labels.added;
        if (accessories) accessories.hidden = false;
        show();setStatus(labels.loading);
        render(await request('cart.js'));setStatus();
        if (formStatus) formStatus.textContent = labels.added;
      } catch (error) {
        const message = added ? labels.refresh_error : (error.message || labels.error);
        if (formStatus) {formStatus.textContent = message;formStatus.dataset.error = 'true';}
        setStatus(message,true);
        if (added) retry.hidden = false;
      } finally {
        setBusy(false);button.disabled = false;button.textContent = oldText;
        form?.closest('[data-ct-pd-root]')?.dispatchEvent(new CustomEvent('ct:cart-busy',{detail:false}));
      }
    };
    const change = async (key, quantity, nativePage = false) => {
      if (busy) return;
      setBusy(true);setStatus(labels.updating);confirmation.hidden = true;
      try {
        if (!cart) cart = await request('cart.js');
        const parent = cart.items.find(item => item.key === key);
        let next = await request('cart/change.js',{id:key,quantity});
        if (quantity > 0 && parent?.properties?._ct_build) {
          const current = next.items.find(item => !item.parent_relationship?.parent_key && item.properties?._ct_build === parent.properties._ct_build);
          const children = current ? next.items.filter(item => item.parent_relationship?.parent_key === current.key) : [];
          const updates = Object.fromEntries(children.filter(item => item.quantity !== current.quantity).map(item => [item.key,current.quantity]));
          if (Object.keys(updates).length) next = await request('cart/update.js',{updates});
        }
        render(next);setStatus();
        if (nativePage) window.location.reload();
      }
      catch (error) {if (nativePage) show();setStatus(error.message || labels.error,true);retry.hidden = false;}
      finally {setBusy(false);}
    };
    const quickDialog = document.querySelector('[data-ct-quick-dialog]');
    let quickOpener = null;
    const openQuick = form => {
      const card = form.closest('[data-ct-home-variants],[data-ct-cl-card]');
      const script = card?.querySelector('[data-ct-home-variant-data],[data-ct-cl-product]');
      if (!script || !quickDialog) {const button = form.querySelector('[data-ct-pd-add]');add(form.querySelector('[name=id]').value,1,form,button);return;}
      const product = JSON.parse(script.textContent);
      product.variants.forEach(variant => {variant.priceText = plainMoney(variant.priceText);});
      let selected = product.variants.find(variant => variant.id === Number(form.querySelector('[name=id]').value)) || product.variants.find(variant => variant.available) || product.variants[0];
      const options = product.options || [];
      if (options.length === 1 && options[0].values.length === 1 && options[0].values[0].value === 'Default Title') {add(selected.id,1,form,form.querySelector('[data-ct-pd-add]'));return;}
      const quickForm = quickDialog.querySelector('[data-ct-quick-form]');
      const fields = quickDialog.querySelector('[data-ct-quick-options]');fields.replaceChildren();
      const status = quickForm.querySelector('[data-ct-form-status]');status.textContent = '';status.dataset.error = 'false';
      quickDialog.querySelector('[data-ct-quick-title]').textContent = card.dataset.ctTitle || product.title || '';
      const image = quickDialog.querySelector('[data-ct-quick-image]');image.alt = card.dataset.ctTitle || product.title || '';
      const selectors = options.map((option,index) => {
        const label = element('label','',option.name);
        const select = element('select');select.setAttribute('aria-label',option.name);select.dataset.optionIndex = String(index);
        const values = option.kind === 'configuration' ? [...option.values].sort((a,b) => a.tier-b.tier) : option.values;
        values.forEach(value => {const choice = element('option','',value.label);choice.value = value.value;choice.disabled = !product.variants.some(variant => variant.available && variant.options[index] === value.value);select.append(choice);});
        label.append(select);fields.append(label);return select;
      });
      const update = variant => {
        selected = variant;
        selectors.forEach((select,index) => {select.value = variant.options[index];});
        quickDialog.querySelector('[data-ct-quick-variant]').value = String(variant.id);
        quickDialog.querySelector('[data-ct-quick-price]').textContent = variant.priceText;
        const src = variant.image || product.image || card.querySelector('img')?.src;
        if (src) image.src = src;
        quickDialog.querySelector('[data-ct-quick-details]').href = `${product.url}?variant=${variant.id}`;
        const display = options.map((option,index) => option.values.find(value => value.value === variant.options[index])?.label || variant.options[index]);
        quickDialog.querySelector('[data-ct-quick-selection]').textContent = display.join(' / ');
        const button = quickDialog.querySelector('[data-ct-quick-submit]');button.disabled = !variant.available;button.textContent = variant.available ? labels.add : labels.sold_out;
      };
      selectors.forEach((select,index) => select.addEventListener('change',() => {
        const values = selectors.map(selector => selector.value);
        let variant = product.variants.find(candidate => candidate.options.every((value,i) => value === values[i]));
        if (!variant) {
          const choices = product.variants.filter(candidate => candidate.options[index] === values[index]);
          choices.sort((a,b) => {const score = candidate => candidate.options.reduce((sum,value,i) => sum+(value === values[i] ? (options[i].kind === 'configuration' ? 10 : 2) : 0),candidate.available ? .1 : 0);return score(b)-score(a);});
          variant = choices[0];
        }
        if (variant) update(variant);
      }));
      update(selected);quickOpener = form.querySelector('[data-ct-pd-add]');quickDialog.showModal();document.documentElement.classList.add('ct-quick-open');
    };
    quickDialog?.querySelector('[data-ct-quick-close]').addEventListener('click',() => quickDialog.close());
    quickDialog?.addEventListener('close',() => {document.documentElement.classList.remove('ct-quick-open');quickOpener?.focus();});
    quickDialog?.addEventListener('click',event => {if (event.target === quickDialog) {const rect = quickDialog.getBoundingClientRect();if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) quickDialog.close();}});
    document.addEventListener('click',event => {
      const build = event.target.closest('[data-ct-cart-build]');
      const control = event.target.closest('[data-quantity-selector],[data-cart-remove]');
      if (build && control) {
        event.preventDefault();event.stopImmediatePropagation();
        const input = build.querySelector('[data-quantity-value]');
        const quantity = control.hasAttribute('data-cart-remove') ? 0 : Math.max(0,Number(input.value)+(control.hasAttribute('data-increase-qty') ? 1 : -1));
        change(build.dataset.ctCartKey,quantity,true);return;
      }
      const trigger = event.target.closest('[data-ct-open-cart]');
      if (trigger) {event.preventDefault();event.stopImmediatePropagation();open();}
    },true);
    document.addEventListener('change',event => {
      const build = event.target.closest('[data-ct-cart-build]');
      if (!build || !event.target.matches('[data-quantity-value]')) return;
      event.preventDefault();event.stopImmediatePropagation();
      change(build.dataset.ctCartKey,Math.max(1,Math.floor(Number(event.target.value)||1)),true);
    },true);
    document.addEventListener('submit',event => {
      const form = event.target;
      if (!form.matches('[data-ct-product-form]')) return;
      event.preventDefault();event.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      if (form.hasAttribute('data-ct-card-form')) {openQuick(form);return;}
      const button = form.querySelector('[data-ct-pd-add]');
      if (!button.disabled) add(form.querySelector('[name=id]').value,form.querySelector('[name=quantity]').value,form,button);
    },true);
    dialog.querySelector('[data-ct-cart-close]').addEventListener('click',close);
    dialog.addEventListener('cancel',event => {event.preventDefault();close();});
    dialog.addEventListener('click',event => {
      if (event.target === dialog) close();
      const quantity = event.target.closest('[data-ct-cart-quantity]');
      if (quantity) change(quantity.closest('[data-key]').dataset.key,Number(quantity.dataset.ctCartQuantity));
    });
    dialog.querySelector('[data-ct-cart-hide-accessories]')?.addEventListener('click',() => {accessories.hidden = true;});
    retry.addEventListener('click',read);
    dialog.querySelectorAll('[data-ct-cart-recommendation]').forEach(card => {
      const info = JSON.parse(card.querySelector('[data-ct-cart-recommendation-data]').textContent);
      info.variants.forEach(variant => {variant.priceText = plainMoney(variant.priceText);});
      const select = card.querySelector('[data-ct-cart-recommendation-variant]');
      const button = card.querySelector('[data-ct-cart-add-recommendation]');
      const update = () => {const variant = info.variants.find(v => v.id === Number(select.value));card.querySelector('[data-ct-recommendation-price]').textContent = variant?.priceText || '';button.disabled = !variant?.available;button.textContent = variant?.available ? labels.add : labels.sold_out;};
      select.addEventListener('change',update);button.addEventListener('click',() => {if (!button.disabled) add(select.value,1,null,button);});
      card.querySelector('[data-ct-cart-show-recommendation]')?.addEventListener('click',() => {
        if (!accessories) return;
        accessories.hidden = false;
        const target = accessories.querySelector(`[data-product-id="${card.dataset.productId}"]`);
        accessories.querySelectorAll('.is-highlighted').forEach(el => el.classList.remove('is-highlighted'));
        target?.classList.add('is-highlighted');target?.querySelector('select')?.focus();
      });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

